import * as React from "react";
import type { SVGProps } from "react";
const SvgTaxi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 17H6c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM17 17h1c.55 0 1-.45 1-1s-.45-1-1-1h-1c-.55 0-1 .45-1 1s.45 1 1 1ZM11.995 18.25c-.748 0-1.507-.09-2.235-.28a1 1 0 0 1-.73-1.21c.13-.53.68-.86 1.21-.73 1.15.29 2.37.29 3.51 0a.995.995 0 0 1 1.21.73.995.995 0 0 1-.73 1.21c-.728.18-1.487.28-2.235.28Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m7.19 5.12.84-3.36C8.14 1.31 8.54 1 9 1h6c.46 0 .86.31.97.76l.84 3.36a3.986 3.986 0 0 1 2.82 2.62l.556 1.671c.204-.278.536-.43.87-.411H23c.55 0 1 .45 1 1s-.45 1-1 1h-1.39l-.5.999.57 1.131c.21.41.32.88.32 1.34v3.06c0 .46-.11.93-.32 1.34l-.79 1.58A1 1 0 0 1 20 21h-.01v.49c0 .83-.68 1.51-1.51 1.51H16.5c-.83 0-1.51-.68-1.51-1.51V21h-6v.49c0 .83-.68 1.51-1.51 1.51H5.5c-.83 0-1.51-.68-1.51-1.51V21a.977.977 0 0 1-.88-.55l-.79-1.58c-.21-.41-.32-.88-.32-1.34v-3.06c0-.46.11-.93.32-1.34l.562-1.116L2.375 11H1c-.55 0-1-.45-1-1s.45-1 1-1h2a1 1 0 0 1 .812.418L4.37 7.74a3.986 3.986 0 0 1 2.82-2.62ZM8 7h8c.03 0 .059-.001.088-.004.76.097 1.399.616 1.642 1.354l.984 2.944c-1.598.385-3.544.706-6.594.706h-.11c-3.056-.008-5.089-.324-6.74-.715l.98-2.935c.253-.74.897-1.26 1.652-1.355.033.003.065.005.098.005Zm1.28-2h5.44l-.5-2H9.78l-.5 2Zm10.193 8.177c-1.77.44-3.905.823-7.353.823H12c-3.432 0-5.666-.381-7.49-.83l-.42.84c-.07.14-.11.29-.11.45v3.06c0 .15.04.31.11.45L4.6 19h14.78l.51-1.03c.07-.14.11-.29.11-.45v-3.06c0-.15-.04-.31-.11-.45l-.417-.833Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTaxi;
